<!-- TODO: Redesign nach Anforderungen -->

<template>
  <div class="container my-5">
    <h2>Fehler bei der Bearbeitung</h2>

    <p>
      Die Übermittlung der Daten an uns hat nicht geklappt. Bitte versuchen Sie es erneut.<br />
      Bitte wenden Sie sich an unsere <a href="https://www.christ.de/store-finder#filialsuche" target="_blank">Fachgeschäfte vor Ort</a> oder an unseren <a href="https://www.christ.de/kundenservice/contact" target="_blank">Kundenservice</a> (kostenlose Hotline: 0800 1863 300).
    </p>

    <div class="mt-4 d-flex flex-wrap justify-content-between form-buttons">
      <router-link
        class="btn mb-3 btn-primary"
        :to="{ name: 'Diagnosis' }"
      >
        Weitere Diagnose durchführen
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error'
}
</script>
